<template>
  <!-- Login-Registration Form-->
  <div class="registration-login-form">
    <nav-tab-panes />
  </div>
  <!-- ... end Login-Registration Form-->
</template>

<script>
import NavTabPanes from './login-registration/NavTabPanes'

export default {
  name: 'RegistrationLoginForm',
  components: { NavTabPanes },
  computed: {},
  methods: {}
}
</script>
